import { module } from 'modujs';
import gsap from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.missionCount = this.el.querySelectorAll('.c-mission_value').length;
        this.wrap = this.el.querySelector('.c-mission_values_wrap');
        this.numbersWrap = this.el.querySelector('.c-mission_values_wrap > ul');
        this.missionContainer = document.querySelector('.c-mission_container');
        this.currentIndex = 0;
        this.interval = null;

        this.updateSize();
        window.addEventListener("resize",() => {
            this.updateSize();
        });
    }

    updateMission(itemId){
        gsap.set(
            this.numbersWrap,
            { y: (-100 * (itemId / this.missionCount)) + '%' }
        );
    }

    updateSize() {
        this.wrap.style.height = this.numbersWrap.querySelector('li').offsetHeight + 'px';
    }

    playInterval(){
        this.interval = setInterval(() => {
            this.currentIndex++;
            if (this.currentIndex >= this.missionCount) {
                this.currentIndex = 0;
            }
            this.updateMission(this.currentIndex);
        }, 4000);
    }

    play(e){
        if (e.way == 'enter') {
            this.playInterval();
            this.missionContainer.classList.add('-visible');
        } else {
            clearInterval(this.interval);
        }
    }
}
